import axios from 'axios';

// ✅ FINAL FIX: Same origin - no CORS!
// Frontend = port 9000
// API calls = port 9000/api/ → Nginx → 9001
// Same origin = No stripping!
//export const API_BASE = window.location.origin + '/api';
// ✅ .env இல் இருந்து எடுக்க hardcode இல்லை!
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:9001';
//export const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.jsmstock.com';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// ✅ Token on every request
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// ✅ Response handler
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 401) {
      localStorage.removeItem('token');
      window.location.reload();
    }
    if (status === 403) {
      if (detail === 'trial_expired') {
        localStorage.removeItem('token');
        window.location.href = '/trial-expired';
      } else if (detail?.includes('lock')) {
        alert('🔒 ' + detail);
      } else if (detail === 'Account disabled!') {
        localStorage.removeItem('token');
        alert('❌ Account disabled!');
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
